/**
 * Single source of truth for inspection/task status across the admin app.
 * Statuses in the data: "pending" | "in progress" | "completed" | "cancelled"
 * | "missed" (a window that closed with the inspection still open).
 * Maps each to a semantic Ant Tag color (tinted by the Warm Residential theme)
 * and a display label. Used by the dashboard, the inspection list, and the
 * task-details page so the same status never renders two different ways.
 */
export const normalizeStatus = (status) => {
  const s = String(status || "pending").toLowerCase();
  if (s.includes("complete")) return "completed";
  if (s.includes("cancel")) return "cancelled";
  if (s.includes("miss")) return "missed";
  if (s.includes("progress")) return "in progress";
  return "pending";
};

const META = {
  pending: { color: "error", label: "Pending" },
  "in progress": { color: "warning", label: "In progress" },
  completed: { color: "success", label: "Completed" },
  cancelled: { color: "default", label: "Cancelled" },
  missed: { color: "default", label: "Missed" },
};

export const statusMeta = (status) => META[normalizeStatus(status)];
export const statusColor = (status) => statusMeta(status).color;
export const statusLabel = (status) => statusMeta(status).label;
